import React from 'react';
import ContentLoader from './ThemedContentLoader';

const PlayingPreloader = (props) => (
  <ContentLoader
    speed={2}
    width={658}
    height={112}
    viewBox="0 0 658 112"
    {...props}
  >
    <rect x="28" y="28" rx="4" ry="4" width="220" height="28" />
    <rect x="28" y="68" rx="4" ry="4" width="140" height="12" />
  </ContentLoader>
);

export default PlayingPreloader;
